import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxCurrencyModule } from 'ngx-currency';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { ComboEdicaoParticipanteReuniaoModule } from '../common/combo-edicao-participante-reuniao/combo-edicao-participante-reuniao.module';
import { ComboEdicaoResponsavelAcaoReuniaoModule } from '../common/combo-edicao-responsavel-acao-reuniao/combo-edicao-responsavel-acao-reuniao.module';
import { ComboPesquisaParticipanteReuniaoModule } from '../common/combo-pesquisa-participante-reuniao/combo-pesquisa-participante-reuniao.module';
import { ComboPesquisaRelatorReuniaoModule } from '../common/combo-pesquisa-relator-reuniao/combo-pesquisa-relator-reuniao.module';
import { ComboPessoaFisicaModule } from '../common/combo-pessoa-fisica/combo-pessoa-fisica.module';
import { ComboReuniaoModule } from '../common/combo-reuniao/combo-reuniao.module';
import { ComboTipoReuniaoModule } from '../common/combo-tipo-reuniao/combo-tipo-reuniao.module';
import { UnidadesMultiplasModule } from './../common/unidades-multiplas/unidades-multiplas.module';
import { AcaoReuniaoComponent } from './cadastrar-reuniao/acao-reuniao/acao-reuniao.component';
import { CadastrarAcoesReuniaoComponent } from './cadastrar-reuniao/acao-reuniao/cadastrar-acoes-reuniao/cadastrar-acoes-reuniao.component';
import { ListarAcoesReuniaoComponent } from './cadastrar-reuniao/acao-reuniao/listar-acoes-reuniao/listar-acoes-reuniao.component';
import { CadastrarReuniaoComponent } from './cadastrar-reuniao/cadastrar-reuniao.component';
import { DadosReuniaoComponent } from './cadastrar-reuniao/dados-reuniao/dados-reuniao.component';
import { CadastrarParticipantesReuniaoComponent } from './cadastrar-reuniao/participantes-reuniao/cadastrar-participantes-reuniao/cadastrar-participantes-reuniao.component';
import { ListarParticipantesReuniaoComponent } from './cadastrar-reuniao/participantes-reuniao/listar-participantes-reuniao/listar-participantes-reuniao.component';
import { ParticipantesReuniaoComponent } from './cadastrar-reuniao/participantes-reuniao/participantes-reuniao.component';
import { ReuniaoRoutingModule } from './reuniao-routing.module';
import { ReuniaoComponent } from './reuniao.component';



@NgModule({
  declarations: [
    AcaoReuniaoComponent,
    ListarParticipantesReuniaoComponent,
    ListarAcoesReuniaoComponent,
    CadastrarParticipantesReuniaoComponent,
    ReuniaoComponent,
    CadastrarReuniaoComponent,
    DadosReuniaoComponent,
    CadastrarAcoesReuniaoComponent,
    ParticipantesReuniaoComponent
  ],
  imports: [
    CommonModule,
    ReuniaoRoutingModule,
    ComboReuniaoModule,
    ComboPesquisaParticipanteReuniaoModule,
    ComboEdicaoParticipanteReuniaoModule,
    ComboTipoReuniaoModule,
    ComboPesquisaRelatorReuniaoModule,
    ComboEdicaoResponsavelAcaoReuniaoModule,
    ComboPessoaFisicaModule,
    MatTabsModule,
    MaterialCommonModule,
    UnidadesMultiplasModule,
    NgxCurrencyModule,
  ]
})
export class ReuniaoModule { }
